module.exports = __webpack_public_path__ + "media/images/features/7/schedule-2-c26944b6dd05f877281212c1cb6e5185.jpg";